module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Title","siteName":"Site name","authorName":"Author name","reviewedAt":"Reviewed at","summary":"Summary","pros":"Pros","cons":"Cons","url":"Link","compare":"Compare","fetch":"Fetch","fetchMerge":"Fetch & Merge"}}')
  delete Component.options._Ctor
}
